import Appeals from './container'

export default Appeals
